document.querySelectorAll(".influencer__header").forEach((head) => {
  head.querySelectorAll(".influencer__avatar").forEach((avatar) => {
    avatar.addEventListener("click", (e) => {
      e.stopPropagation();
      const influencerTag = e.target.parentNode.getAttribute("for");
      const blockId = e.target.parentNode.getAttribute("block");

      document
        .querySelectorAll(`influencer-details`)
        .forEach((details) => details.classList.remove("active"));
      document
        .querySelectorAll(`#${influencerTag}`)
        .forEach((influencer) => influencer.classList.add("active"));
    });
  });
});
